/**
 * 创建一个 mutation observer
 * 用于检测 dom 元素是否有变化
 */
export var DEFAULT_OBSERVER_OPTIONS = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
};
export function createMutationObserver(dom, callback, options) {
    if (options === void 0) { options = DEFAULT_OBSERVER_OPTIONS; }
    var observer = new MutationObserver(callback);
    observer.observe(dom, options);
    return observer;
}
//# sourceMappingURL=mutation.js.map